import React, { useState, useEffect } from "react";
import axios from "axios"; // Ensure axios is installed
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import Navbar from "../component/Navbar";

import { baseurl, imgurl } from "../baseurl";

// SWIPER STYLES
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "../asset/css/navbar.css";
import HomeBooking from "./HomeComponent/HomeBooking";
import About from "./About";
import PopularPackages from "./HomeComponent/PopularPackages";
import CabService from "./HomeComponent/CabService";
import YatraPackages from "./HomeComponent/YatraPackages";
import Footer from "../component/Footer";

const Home = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch Banners from API
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${baseurl}/getBanners`);
        if (response.data.status === "success") {
          setBanners(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading Adventure...</div>;
  }

  return (
    <>
     
      <section className="hero-slider-wrapper">
        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          effect="fade"
          loop={banners.length > 1} // Only loop if more than 1 banner
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          // navigation
          pagination={{ clickable: true }}
          className="hero-swiper"
        >
          {banners.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="slide-content-wrap">
                {/* Image handled via imgurl and file_path from API */}
                <img 
                  src={`${imgurl}/${slide.file_path}`} 
                  alt="Travel Banner" 
                  className="slide-img" 
                />
                
                {/* Text Overlay */}
                <div className="slide-overlay d-flex align-items-center">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-7 text-white text-center text-lg-start">
                        {/* <h5 className="hero-badge text-uppercase mb-3 animate-up">
                          <i className="bi bi-stars me-2"></i>Discover the Unseen
                        </h5>
                        <h3 className="hero-title mb-4 animate-up delay-1">
                          Explore The World <br /> 
                          With <span className="text-green">Confidence</span>
                        </h3> */}
                        {/* <p className="hero-description mb-5 animate-up delay-2">
                          We provide hand-picked destinations and unique travel experiences tailored just for you.
                        </p> */}
                        {/* <div className="d-flex justify-content-center justify-content-lg-start gap-3 animate-up delay-3">
                          <button className="btn btn-green rounded-pill text-uppercase fw-bold px-5 py-3 shadow">
                            Book A Trip
                          </button>
                          <button className="btn btn-outline-cyan rounded-pill text-uppercase fw-bold px-5 py-3">
                            View Gallery
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>


<PopularPackages/>
<YatraPackages />
{/* <HomeBooking/> */}
<About/>

<CabService />


<Footer />
    </>
  );
};

export default Home;